/**
 * InkyPic Image Uploader Component
 * Handles drag-and-drop and file browsing for image uploads
 */

import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import '../styles/ImageUploader.css';

const ImageUploader = ({ onImageSelect, disabled = false }) => {
  const onDrop = useCallback(
    (acceptedFiles) => {
      if (acceptedFiles && acceptedFiles.length > 0) {
        onImageSelect(acceptedFiles[0]);
      }
    },
    [onImageSelect]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'image/jpeg': ['.jpg', '.jpeg'],
      'image/png': ['.png'],
    },
    maxFiles: 1,
    maxSize: 10 * 1024 * 1024, // 10MB
    disabled,
  });

  return (
    <div
      {...getRootProps()}
      className={`uploader-container ${isDragActive ? 'drag-active' : ''} ${disabled ? 'disabled' : ''}`}
    >
      <input {...getInputProps()} />
      <div className="uploader-content">
        <div className="upload-icon">📸</div>
        {isDragActive ? (
          <p className="upload-text">Drop your image here</p>
        ) : (
          <>
            <p className="upload-text">
              Drag & drop a black and white image here
            </p>
            <p className="upload-text-secondary">or</p>
            <button className="browse-button" type="button" disabled={disabled}>
              Browse Files
            </button>
            <p className="upload-hint">
              Supported formats: JPG, PNG • Max size: 10MB
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default ImageUploader;
